import React, { useState } from "react";
import { get } from "lodash";
import BaseCheckbox from "../BaseCheckbox";
import CarouselComponent from "@/components/CarouselComponent";

import "./index.less";

// 行多选
export default function MatrixCheckbox({ info, answer, changeAnswer }) {
  console.log("src\\pages\\checkbox\\MatrixCheckbox\\index.jsx");
  let {
    id,
    childs,
    scripts = [],
    preferences: { optionPrefer = {} },
  } = info;
  // 点击选项
  const [carouseFn, setcarouseFn] = useState(null);
  const onChangeAnswer = (subId, newAnswer) => {
    changeAnswer({
      ...get(answer, `[${id}]`, {}),
      [subId]: newAnswer,
    });
  };

  return (
    <div className="matrix-checkbox">
      <div className="q-matrix-content">
        <CarouselComponent
          colData={childs}
          info={info}
          callback={(dom, autoplayFn, current) => {
            setcarouseFn({ ...dom, autoplayFn, current });
          }}
        >
          {(childs || []).map((child, index) => {
            if (+child.moduleOption > 0) {
              if (+child.moduleOption === 2) {
                return null;
              } else {
                return (
                  <div className="q-item q-item-module" key={child.id}>
                    <div
                      className="q-item-title q-item-title-module"
                      dangerouslySetInnerHTML={{
                        __html: child.description
                          .replace(/<p><\/p>/g, "<br />")
                          .replace(/\n\n/g, "<br />")
                          .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                      }}
                    />
                  </div>
                );
              }
            }
            const cid = child.id;
            const answerProp = answer[info.id]?.[cid]
              ? { [cid]: answer[info.id][cid] }
              : {};
            return (
              <div className="q-item" key={child.id}>
                <div
                  id={cid}
                  className="q-item-title"
                  dangerouslySetInnerHTML={{
                    __html: child.description
                      .replace(/<p><\/p>/g, "<br />")
                      .replace(/\n\n/g, "<br />")
                      .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                  }}
                />
                <div className="q-item-content">
                  <BaseCheckbox
                    info={{ ...child, scripts, optionPrefer, id: child.id }}
                    answer={answerProp}
                    changeAnswer={(newAnswer) => {
                      carouseFn && carouseFn.autoplayFn();
                      onChangeAnswer(child.id, newAnswer);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </CarouselComponent>
      </div>
    </div>
  );
}
